import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const QUICK_ADD_FADE_IN_DURATION = theme.transitions.base;
export const QUICK_ADD_LAYOUT_DURATION = theme.transitions.base;
export const QUICK_ADD_ENTRANCE_DURATION = theme.transitions.long;
export const QUICK_ADD_STAGGER_DELAY = 80;
